import React, { useEffect, useRef } from 'react';

const InternalResistanceVsCyclePlot = () => {
  const plotRef = useRef(null);

  useEffect(() => {
    // Load Plotly script if not already loaded
    if (!window.Plotly) {
      const script = document.createElement('script');
      script.src = 'https://cdn.plot.ly/plotly-latest.min.js';
      script.onload = () => {
        renderPlot();
      };
      document.head.appendChild(script);
    } else {
      renderPlot();
    }

    function renderPlot() {
      const plot_json = {
        "data": [
          {
            "mode": "lines",
            "name": "Internal Resistance vs. Cycle",
            "x": [0.0, 2.842809364548495, 5.68561872909699, 17.05685618729097, 19.899665551839465, 36.95652173913042, 51.17056856187289, 54.01337792642138, 56.85618729096988, 144.9832775919733, 147.82608695652178, 150.66889632107026, 153.51170568561875, 156.35451505016724, 159.19732441471572, 164.8829431438127, 167.72575250836118, 170.56856187290967, 204.6822742474915, 213.21070234113697, 218.89632107023397, 241.63879598662183, 244.48160535117032, 253.01003344481575, 255.85284280936423, 258.6956521739128, 261.53846153846126, 272.9096989966552, 275.7525083612037, 295.6521739130431, 298.4949832775916, 309.86622073578553, 312.709030100334, 315.5518394648825, 318.394648829431, 326.92307692307645, 335.4515050167219, 338.2943143812704, 341.1371237458189, 343.97993311036737, 346.82274247491586, 355.3511705685613, 358.1939799331098, 386.62207357859467, 389.4648829431432, 400.8361204013371, 403.6789297658856, 412.20735785953104, 415.05016722407953, 417.892976588628, 420.7357859531765, 423.578595317725, 426.4214046822735, 437.7926421404674, 440.6354515050159, 469.0635451505008, 471.90635451504926, 474.74916387959775, 477.59197324414623, 488.9632107023402, 491.8060200668887, 494.6488294314372, 497.4916387959856, 500.3344481605341, 523.0769230769222, 525.9197324414707, 528.7625418060193, 540.1337792642134, 577.0903010033445, 579.933110367893, 585.6187290969901, 588.4615384615387, 591.3043478260872, 594.1471571906358, 596.9899665551843, 622.5752508361212, 625.4180602006697, 628.2608695652183, 631.1036789297668, 633.9464882943154, 636.7892976588639, 639.6321070234125, 642.474916387961, 645.3177257525095, 673.745819397995, 676.5886287625435, 696.4882943143833, 699.3311036789319, 702.1739130434804, 705.016722408029, 707.8595317725775, 710.702341137126, 713.5451505016746, 716.3879598662231, 719.2307692307717, 724.9163879598688, 727.7591973244173, 730.6020066889658, 733.4448160535144, 736.2876254180629, 747.6588628762571, 750.5016722408056, 753.3444816053542, 756.1872909699027, 759.0301003344513, 761.8729096989998, 767.5585284280969, 770.4013377926454, 773.244147157194, 776.0869565217425, 784.6153846153882, 787.4581939799367, 790.3010033444853, 793.1438127090338, 795.9866220735823, 798.8294314381309, 801.6722408026794, 804.515050167228, 807.3578595317765, 810.200668896325, 813.0434782608736, 815.8862876254221, 818.7290969899707, 821.5719063545192, 824.4147157190678, 830.1003344481649, 832.9431438127134, 835.785953177262, 838.6287625418105, 841.471571906359, 844.3143812709076, 847.1571906354561, 850.0000000000047],
            "y": [0.9302325581395349, 0.9302325581395349, 0.9302325581395349, 0.9302325581395349, 0.9302325581395349, 0.9320146128486146, 0.9338035084586886, 0.9338035084586886, 0.9338035084586886, 0.9428519920677844, 0.9446827726349064, 0.9446827726349064, 0.9446827726349064, 0.9446827726349064, 0.9446827726349064, 0.9465206768618224, 0.9465206768618224, 0.9465206768618224, 0.9520775497201109, 0.9520775497201109, 0.9520775497201109, 0.9558185224105632, 0.9577000549349935, 0.9595890096784551, 0.9595890096784551, 0.9595890096784551, 0.9595890096784551, 0.9614854306461991, 0.9614854306461991, 0.9672199361967729, 0.9672199361967729, 0.9691466691374039, 0.9691466691374039, 0.9691466691374039, 0.9691466691374039, 0.9710810936267, 0.9730232558139535, 0.9730232558139535, 0.9749732022183902, 0.9749732022183902, 0.9749732022183902, 0.976930979732885, 0.976930979732885, 0.9848413520384147, 0.9848413520384147, 0.9908587126415005, 0.9908587126415005, 0.9928808732795444, 0.994911304513245, 0.9969500571864278, 0.9969500571864278, 0.9969500571864278, 0.9969500571864278, 0.9989971825605272, 0.9989971825605272, 1.039554760484993, 1.0373382258144492, 1.0373382258144492, 1.039554760484993, 1.017806752943466, 1.017806752943466, 1.017806752943466, 1.0199405197211253, 1.0199405197211253, 1.0307449743791879, 1.0307449743791879, 1.0307449743791879, 1.039554760484993, 1.0622524626789884, 1.064576866317236, 1.0669114647082825, 1.0692563250702785, 1.0716115152136052, 1.07397710354741, 1.07397710354741, 1.0982203790225211, 1.0982203790225211, 1.1007050405135221, 1.103200970310605, 1.1057082452431288, 1.1367094109976092, 1.1420460748990064, 1.1447332421340628, 1.158361018826135, 1.15287115617767, 1.1556095674750042, 1.1895149826576448, 1.1895149826576448, 1.2012632787826585, 1.2042367027400414, 1.2042367027400414, 1.2102279301168575, 1.2193273882380369, 1.2223910248919014, 1.2316750073594347, 1.2474657125819917, 1.2506725653135649, 1.260392818411857, 1.2636665659921476, 1.2669573643410854, 1.3113520967843038, 1.3220424671385238, 1.329266742915237, 1.3365704063378483, 1.3551855930556456, 1.3551855930556456, 1.3980219192729215, 1.4061029708294124, 1.422548619611043, 1.4309165526675787, 1.4923669567698672, 1.5062279501763984, 1.5251148210250054, 1.5395937591992934, 1.574471287724844, 1.5951200914982844, 1.6163177006876304, 1.627129190324337, 1.6834312384324455, 1.7010896080663522, 1.7375415282392026, 1.7627232895180318, 1.7952458594353387, 1.8289910823570552, 1.8498540985056149, 1.95386195946577, 1.969682704076829, 1.977689544337304, 2.088032737798183, 2.088032737798183, 2.1061109433202456, 2.2419890686957453, 2.2419890686957453],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "Initial cycle",
            "x": [0.0],
            "y": [0.9302325581395349],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "Knee onset",
            "x": [702.1739130434804],
            "y": [1.2012632787826585],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "Knee point",
            "x": [784.6153846153882],
            "y": [1.4923669567698672],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "EOL",
            "x": [850.0000000000047],
            "y": [2.2419890686957453],
            "type": "scatter"
          },
          {
            "marker": {"color": "purple", "size": 15, "symbol": "star"},
            "mode": "markers",
            "name": "SoH (This Cell): 275",
            "x": [275],
            "y": [0.9614854306461991],
            "type": "scatter"
          }
        ],
        "layout": {
          "annotations": [
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "Initial cycle", "x": 0.0, "y": 0.9302325581395349},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "Knee onset", "x": 702.1739130434804, "y": 1.2012632787826585},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "Knee point", "x": 784.6153846153882, "y": 1.4923669567698672},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "EOL", "x": 850.0000000000047, "y": 2.2419890686957453},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "SoH (This Cell): 275", "x": 275, "y": 0.9614854306461991}
          ],
          "modebar": {"orientation": "v"},
          "showlegend": true,
          "title": {"text": "Internal Resistance vs. Cycle Plot"},
          "xaxis": {
            "title": {"text": "Cycle"},
            "gridcolor": "#283442",
            "linecolor": "#506784",
            "tickcolor": "#506784",
            "tickfont": {"color": "#f2f5fa"},
            "zerolinecolor": "#283442",
            "zerolinewidth": 2,
            "showgrid": true
          },
          "yaxis": {
            "title": {"text": "Internal Resistance (mOhm)"},
            "gridcolor": "#283442",
            "linecolor": "#506784",
            "tickcolor": "#506784",
            "tickfont": {"color": "#f2f5fa"},
            "zerolinecolor": "#283442",
            "zerolinewidth": 2,
            "showgrid": true
          },
          "paper_bgcolor": "black",
          "plot_bgcolor": "black",
          "font": {"color": "#f2f5fa"}
        }
      };

      // Convert y data from Ohm to mOhm
      plot_json.data.forEach(function(trace) {
        if (trace.y) {
          trace.y = trace.y.map(function(val) { return val * 1000; });
        }
      });
      if (plot_json.layout && Array.isArray(plot_json.layout.annotations)) {
        plot_json.layout.annotations.forEach(function(annotation) {
          if (typeof annotation.y === 'number') {
            annotation.y = annotation.y * 1000;
          }
        });
      }

      if (plotRef.current) {
        window.Plotly.newPlot(plotRef.current, plot_json.data, plot_json.layout, {responsive: true});
      }
    }

    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <div 
      ref={plotRef} 
      style={{ 
        width: '100%', 
        height: '500px',
        backgroundColor: 'black'
      }} 
    />
  );
};

export default InternalResistanceVsCyclePlot;
